<template>
<div class="dropdown" @click="handleClick">
    <div v-for="option in options" :key="option.key" :data-key="option.key" :class="['option', { active: option.key === activeKey }]">
        {{ option.label }}
    </div>
</div>
</template>

<script>
export default {
    props: {
        activeKey: {
        },

        options: {
            default () {
                return []
            },
            type: Array
        }
    },

    methods: {
        handleClick (event) {
            const $target = event.target

            if ($target.classList.contains("option") === false) {
                return
            }

            this.$emit("change", $target.dataset.key)
        }
    }
}
</script>

<style>
.dropdown {
    box-shadow: inset 0 1px 2px 0 rgba(0, 0, 0, 0.16), inset 0 0 0 1px rgba(0, 0, 0, 0.08);
    max-height: 275px;
    overflow: auto;
    padding: 5px 0;
}

.option {
    cursor: pointer;
    line-height: 1;
    padding: 7px 10px 5px;
    transition: all 0.05s;
}

.option:hover {
    background: #E8E8E8;
}

.option.active {
    background: #41a6fc;
    color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/DropdownInput.vue